import React, { useState, useRef, useEffect } from 'react';
import { formatTimestamp } from '../../utils/format';

const MAX_BUBBLE_HEIGHT = 500;

export default function ExpandableBubble({ children, bubbleClass, badge, timestamp, isUser }) {
  const contentRef = useRef(null);
  const [overflows, setOverflows] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (contentRef.current) {
      setOverflows(contentRef.current.scrollHeight > MAX_BUBBLE_HEIGHT);
    }
  }, [children]);

  return (
    <div className={`message-bubble ${bubbleClass}`}>

      {timestamp && (
        <div className={`bubble-timestamp ${isUser ? 'bubble-timestamp--user' : ''}`}>
          {formatTimestamp(timestamp)}
        </div>
      )}

      {badge}

      <div
        className={`bubble-content-wrap ${overflows && !expanded ? 'bubble-collapsed' : ''}`}
        ref={contentRef}
      >
        {children}
      </div>

      {overflows && (
        <button
          className={`bubble-expand-btn ${expanded ? 'bubble-expand-btn--open' : ''}`}
          onClick={() => setExpanded(v => !v)}
        >
          {expanded ? '▲ show less' : '▼ show more'}
        </button>
      )}
    </div>
  );
}
